
import { defineComponent, computed } from "vue";
import store from "../store";

import MemoryCard from "./Card.vue";

export default defineComponent({
    data() {
        const cards = computed(() => store.getters.cards);
        const won = computed(() => store.getters.won);
        const score = computed(() => store.getters.score);
        return { cards, won, score };
    },
    name: "card-grid",
    components: { "memory-card": MemoryCard }
});
